import type { Invoice } from "@/lib/invoice.api";
import { DocumentStatusBadge } from "@/pages/documents/components/DocumentWorkspace";
import { PAYMENT_LABELS, PAYMENT_TONES, STATUS_LABELS, STATUS_TONES } from "../invoice.constants";
import { isInvoiceOverdue } from "../invoice-calculations";

interface InvoiceStatusBadgesProps {
  invoice: Invoice;
  includeOverdue?: boolean;
  className?: string;
}

export function InvoiceStatusBadges({
  invoice,
  includeOverdue = false,
  className = "flex flex-wrap gap-1",
}: InvoiceStatusBadgesProps) {
  return (
    <div className={className}>
      <DocumentStatusBadge label={STATUS_LABELS[invoice.status]} tone={STATUS_TONES[invoice.status]} />
      <DocumentStatusBadge
        label={PAYMENT_LABELS[invoice.paymentStatus]}
        tone={PAYMENT_TONES[invoice.paymentStatus]}
      />
      {includeOverdue && isInvoiceOverdue(invoice) && (
        <DocumentStatusBadge label="En retard" tone="danger" />
      )}
    </div>
  );
}
